import { Carrier } from '../types/carrier';

export const mockHubbedCarrier: Carrier = {
  carrier_type: 'Hubbed',
  carrier_name: 'Hubbed',
  service_level: 'standard',
  dropoff: true,
  estimated_transit_time: '1',
};

export const mockEparcelCarrier: Carrier = {
  carrier_type: 'Eparcel',
  carrier_name: 'eParcel',
  service_level: 'standard',
  dropoff: true,
  estimated_transit_time: '3',
};

export const mockCouriersPleaseCarrier: Carrier = {
  carrier_type: 'CouriersPlease',
  carrier_name: 'Couriers Please',
  service_level: 'standard',
  dropoff: false,
  estimated_transit_time: '1',
};

export const mockTNTCarrier: Carrier = {
  carrier_name: 'TNT',
  carrier_type: 'Tnt',
  service_level: 'standard',
  dropoff: false,
  estimated_transit_time: '1',
};

export const mockBondsCarrier: Carrier = {
  carrier_type: 'Bonds',
  carrier_name: 'Bonds',
  service_level: 'priority',
  dropoff: false,
  error: 'cannot transport from Sydney 2000 to Casino 2470.',
};

export const mockSingPostCarrier: Carrier = {
  carrier_type: 'SingPost',
  carrier_name: 'SingPost',
  service_level: 'standard',
  dropoff: true,
  estimated_transit_time: '3',
};

export const mockNinjaVanCarrier: Carrier = {
  carrier_type: 'NinjaVanStandard',
  carrier_name: 'NinjaVan',
  service_level: 'standard',
  dropoff: true,
  estimated_transit_time: '3',
};

export const mockMorningExpressCarroer: Carrier = {
  carrier_type: 'MorningExpress',
  carrier_name: 'Morning Express',
  service_level: 'standard',
  dropoff: true,
  estimated_transit_time: '3',
};

export const mockTeleportCarrier: Carrier = {
  carrier_type: 'Teleport',
  carrier_name: 'Teleport',
  service_level: 'standard',
  dropoff: false,
  estimated_transit_time: '1',
};

export const mockReturnInStoreCarrier: Carrier = {
  carrier_type: 'PlainLabel',
  carrier_name: 'Return in store',
  service_level: 'standard',
  dropoff: true,
};

export const mockSelfReturnsCarrier: Carrier = {
  carrier_type: 'PlainLabel',
  carrier_name: 'Self Return',
  service_level: 'standard',
  dropoff: true,
};
